import { useEffect, useState } from "react";
import { SimCallReceiver } from "../../features/crm/sim-call-receiver";
import { Outlet, useLocation } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";
import { ClientSidebar } from "./ClientSidebar";
import { SfaSidebar } from "./SfaSidebar";
import { SfaSectionTabs } from "./SfaSectionTabs";
import { TopBar } from "./TopBar";
import { AskOverlay } from "../../features/ask/ask-overlay";
import { useAuth } from "../../context/AuthContext";
import { THEME_STORAGE_KEY, applyTheme, readStoredTheme } from "../../lib/theme";
import { canManageAgents } from "../../lib/userAccess";

/**
 * Unified authenticated shell.
 * Single scroll owner: <main>. Pages render plain content into <Outlet />.
 */
export function AppLayout() {
  const { pathname } = useLocation();
  const [dark, setDark] = useState(() => readStoredTheme() === "dark");
  const { user, dashboardSession } = useAuth();
  const isAdminRoute = pathname.startsWith("/admin/");
  const isAgentStudio = pathname === "/home/create-agent" || pathname === "/home/create-workflow";
  const isSfaRoute = pathname.startsWith("/crm");
  // Full-height pages: My Chat + Template hide the global top bar for max space.
  const isWhatsAppChat = pathname.startsWith("/whatsapp/conversations") || pathname.startsWith("/whatsapp/templates");

  useEffect(() => {
    applyTheme(dark ? "dark" : "light");
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, dark ? "dark" : "light");
    } catch {
      // Storage blocked; the theme still applies for this session.
    }
  }, [dark]);

  return (
    <div className="flex h-screen overflow-hidden app-bg font-sans text-ink" style={dashboardSession ? { height: 'calc(100dvh - 3rem)' } : undefined}>
      {!isAgentStudio && (isAdminRoute ? <AdminSidebar /> : <ClientSidebar />)}
      {!isAgentStudio && !isAdminRoute && isSfaRoute && <SfaSidebar />}
      <div className="flex min-w-0 flex-1 flex-col">
        {!isAgentStudio && !isWhatsAppChat && <TopBar theme={dark ? "dark" : "light"} onThemeChange={() => setDark((current) => !current)} />}
        {!isAgentStudio && isSfaRoute && <SfaSectionTabs />}
        {!isAgentStudio && (user?.command_center !== false || canManageAgents(user)) && <AskOverlay />}
        <main className="flex-1 flex flex-col min-h-0 overflow-y-auto">
          <Outlet />
          <SimCallReceiver />
        </main>
      </div>
    </div>
  );
}
